<template>
    <div
            class="VTableBlocks"
    >
        <VFullScreenPopup
                v-if="isShowChartPopup"
                :title="chartPopup.title"
                :is-show-submit-button="false"
                :cancel-button-text="'OK'"
                @cancel="hideChartPopup"
        >
            <div class="popup-chart">
                <component
                        :is="chartComponent"
                        :chart-data="chartData"
                        :options="chartOptions"
                        :style="{height: '100%'}"
                >
                </component>
            </div>
            <template #sidebar>
                <div class="popup-sidebar">
                    <span class="popup-sidebar__label">Events:</span>
                    <template v-for="(event,eventIndex) in events">
                        <VLabel
                                :key="eventIndex"
                                v-if="deletedPopupEvents.includes(event.name)"
                                :color="event.color || '#6089E7'"
                                :font-weight="event.fontWeight"
                                action="add"
                                @click="addEvent(event)"
                        >
                            {{ event.name }}
                        </VLabel>
                        <VLabel
                                class="popup-sidebar-events_added"
                                :key="eventIndex"
                                v-else
                                :color="event.color || '#6089E7'"
                                :font-weight="event.fontWeight"
                                @click="removeEvent(event)"
                        >
                            {{ event.name }}
                        </VLabel>
                    </template>
                    <span class="popup-sidebar__label">Formulas:</span>
                    <template v-for="(formula,formulaIndex) in formulas">
                        <VLabel
                                :key="formulaIndex"
                                v-if="deletedPopupFormulas.includes(formula.name)"
                                :color="'#000000'"
                                action="add"
                                @click="addFormula(formula)"
                        >
                            {{ formula.name }}
                        </VLabel>
                        <VLabel
                                class="popup-sidebar-events_added"
                                :key="formulaIndex"
                                v-else
                                :color="'#000000'"
                                @click="removeFormula(formula)"
                        >
                            {{ formula.name }}
                        </VLabel>
                    </template>
                    <span class="popup-sidebar__label popup-sidebar_display">Display Type:</span>
                    <VRadioSwitcher
                            :options="$refs.vfeatureblock[chartPopup.featureIndex].featureViewsSelected"
                            :type="'Array'"
                            :sync="false"
                            @updateOptions="changeFeatureChart"
                    >
                    </VRadioSwitcher>
                    <span
                            class="popup-sidebar__label"
                            v-if="chartPopup.title === 'Summary'"
                    >  Precision:</span>
                    <VSelect
                            v-if="chartPopup.title === 'Summary'"
                            class="precision-select"
                            :item="localPrecision"
                            @updateItem="updatePrecision"
                            :options="precisionsObjects"
                    >
                        <VButton>{{ localPrecision.name }}</VButton>
                    </VSelect>
                </div>
            </template>
        </VFullScreenPopup>
        <div class="popup-table">
            <VFullScreenPopup
                    v-if="isShowTablePopup"
                    :title="tablePopupFeature.name"
                    :is-show-submit-button="false"
                    :is-show-sidebar="false"
                    :is-show-footer="false"
                    :is-show-header="false"
                    :cancel-button-text="'OK'"
                    @cancel="hideTablePopup"
            >
                <VFeatureBlock
                        v-show="['bundle_id','Summary'].includes(tablePopupFeature.name) ||  featuresNames.includes(tablePopupFeature.name)"
                        :feature="tablePopupFeature"
                        :is-closable="true"
                        :events="events"
                        :deleted-events-and-formulas-indexes="deletedEventsAndFormulasIndexes"
                        :all-events-and-all-formulas="allEventsAndAllFormulas"
                        :all-events="allEvents"
                        :all-formulas="allFormulas"
                        :formulas="formulas"
                        :bundle-ids-options="bundleIdsOptions"
                        :event-switcher-options="eventSwitcherOptions"
                        :feature-settings="featuresSettings[tablePopupFeature.name] || {}"
                        :is-feature-updating="['Summary'].includes(tablePopupFeature.name) ? isSummaryTableUpdating: isFeaturesUpdating"
                        :feature-index="tablePopup.featureIndex"
                        :is-not-summary-table="!['Summary'].includes(tablePopupFeature.name)"
                        :show-headers-names="showHeadersNames"
                        :headers-names="headersNames"
                        :headers-width="headersWidth"
                        :current-board-class="currentBoardClass"
                        :board-styles="boardStyles"
                        :number-type-features-names="numberFeatureTypes"
                        :current-board="currentBoard"
                        :filters="filtersByObject[tablePopupFeature.name]"
                        :is-loaded-from-popup="true"
                        :date-type-features-names="['Summary']"
                        :items-count="50"
                        @selectRow="selectRow"
                        @sumRows="sumRows"
                        @deleteSumRow="deleteSumRow"
                        @selectRowWithShift="selectRowWithShift"
                        @selectAllRowExceptClicked="selectAllRowExceptClicked"
                        @filterClickedRow="filterClickedRow"
                        @applySelection="applySelection"
                        @closeFeature="closeFeature(tablePopup.featureIndex)"
                        @updateFeatureSettingsByProperties="updateFeatureSettingsByProperties"
                        @updateFeatureSettingsByProperty="updateFeatureSettingsByProperty"
                        @changeFeatureViewType="changeFeatureViewType"
                        @showTooltip="showTooltip"
                        @addSelection="addSelection"
                        @showChartPopup="showChartPopup"
                        @showTablePopup="showTablePopup"
                        @hideTablePopup="hideTablePopup"
                        @getChartData="getChartData"
                        @saveDashboardDebouncedLong="saveDashboardDebouncedLong"
                        @saveDashboard="saveDashboard"
                        @addGeoData="addGeoData"
                >
                    <template
                            v-if="currentBoard.cohort && ['Summary'].includes(tablePopupFeature.name) && (!featuresSettings[tablePopupFeature.name].featureView ||
                        featuresSettings[tablePopupFeature.name].featureView.toLowerCase()  !==  'pie')"
                            #afterFeatureName
                    >
                        <div class="summary-VToggle">
                            <VToggle
                                    v-model="currentBoard.groupByCohort"
                                    @click="updateSummaryCohort"
                                    labelAfter="Cohort"
                            ></VToggle>
                        </div>
                    </template>
                    <template
                        v-if="['Summary'].includes(tablePopupFeature.name) && (!featuresSettings[tablePopupFeature.name].featureView ||
                        featuresSettings[tablePopupFeature.name].featureView.toLowerCase()  !==  'pie')"
                        #beforeHeaderSettings
                    >
                        <VSelect
                            class="precision-select"
                            :item="localPrecision"
                            @updateItem="updatePrecision"
                            :options="precisionsObjects"
                        >
                            <VButton>{{ localPrecision.name }}</VButton>
                        </VSelect>
                    </template>
                </VFeatureBlock>
            </VFullScreenPopup>
        </div>
        <draggable
                handle=".VFeatureBlock-title-bar"
                :list="featuresData"
                @change="swapTableBlocks"
                class="VTableBlocks-draggable"
        >
            <template v-for="(feature,featureIndex) in featuresData">
                <VFeatureBlock
                        v-show="['bundle_id','Summary'].includes(feature.name) ||  featuresNames.includes(feature.name)"
                        ref="vfeatureblock"
                        :key="featureIndex"
                        :feature="feature"
                        :is-closable="!['bundle_id','Summary'].includes(feature.name)"
                        :events="events"
                        :deleted-events-and-formulas-indexes="deletedEventsAndFormulasIndexes"
                        :all-events-and-all-formulas="allEventsAndAllFormulas"
                        :all-events="allEvents"
                        :all-formulas="allFormulas"
                        :formulas="formulas"
                        :bundle-ids-options="bundleIdsOptions"
                        :event-switcher-options="eventSwitcherOptions"
                        :feature-settings="featuresSettings[feature.name] || {}"
                        :is-feature-updating="['Summary'].includes(feature.name) ? isSummaryTableUpdating: isFeaturesUpdating"
                        :feature-index="featureIndex"
                        :is-not-summary-table="!['Summary'].includes(feature.name)"
                        :show-headers-names="showHeadersNames"
                        :headers-names="headersNames"
                        :headers-width="headersWidth"
                        :current-board-class="currentBoardClass"
                        :board-styles="boardStyles"
                        :number-type-features-names="numberFeatureTypes"
                        :current-board="currentBoard"
                        :filters="filtersByObject[feature.name]"
                        :date-type-features-names="['Summary']"
                        @selectRow="selectRow"
                        @sumRows="sumRows"
                        @deleteSumRow="deleteSumRow"
                        @selectRowWithShift="selectRowWithShift"
                        @selectAllRowExceptClicked="selectAllRowExceptClicked"
                        @filterClickedRow="filterClickedRow"
                        @filterClickedRowSummaryTable="filterClickedRowSummaryTable"
                        @applySelection="applySelection"
                        @closeFeature="closeFeature(featureIndex)"
                        @updateFeatureSettingsByProperties="updateFeatureSettingsByProperties"
                        @updateFeatureSettingsByProperty="updateFeatureSettingsByProperty"
                        @changeFeatureViewType="changeFeatureViewType"
                        @showTooltip="showTooltip"
                        @addSelection="addSelection"
                        @showChartPopup="showChartPopup"
                        @showTablePopup="showTablePopup"
                        @getChartData="getChartData"
                        @saveDashboardDebouncedLong="saveDashboardDebouncedLong"
                        @saveDashboard="saveDashboard"
                        @clearRowsFromFeature="clearRowsFromFeature(featureIndex)"
                        @addGeoData="addGeoData"
                >
                    <template
                            v-if="currentBoard.cohort && ['Summary'].includes(feature.name) && (!featuresSettings[feature.name].featureView ||
                        featuresSettings[feature.name].featureView.toLowerCase()  !==  'pie')"
                            #afterFeatureName
                    >
                        <div class="summary-VToggle">
                            <VToggle
                                    v-model="currentBoard.groupByCohort"
                                    @click="updateSummaryCohort"
                                    labelAfter="Cohort"
                            ></VToggle>
                            <VToggle
                                    v-model="currentBoard.arppuCoef"
                                    @click="updateArppuCoef"
                                    labelAfter="Coef 0.70/0.85"
                            ></VToggle>
                        </div>
                    </template>
                    <template
                            v-if="['Summary'].includes(feature.name) && (!featuresSettings[feature.name].featureView ||
                        featuresSettings[feature.name].featureView.toLowerCase()  !==  'pie')"
                            #beforeHeaderSettings
                    >
                        <VSelect
                                class="precision-select"
                                :item="localPrecision"
                                @updateItem="updatePrecision"
                                :options="precisionsObjects"
                        >
                            <VButton>{{ localPrecision.name }}</VButton>
                        </VSelect>
                    </template>
                </VFeatureBlock>
            </template>
        </draggable>
    </div>

</template>

<script>
    import draggable from 'vuedraggable';
    import VFeatureBlock from '../../components/VFeatureBlock';
    import apiFeatures from '@/api/apiFeatures';
    import {sortByNumber, roundNumber} from '@/helpers/dataHelper';
    import {
        fractionalEventsWithOriginalNames,
        replaceFullName,
        replacePartFormulaName,
        longNameEventsShortcuts,
    } from './mapping';
    import {
        createCssRules,
        deleteCssRules,
        getTextWidth,
        copyStringToClipboard,
    } from '../../helpers/domHelper';
    import {Parser} from 'hot-formula-parser';
    import {eventBus} from '../../main';
    import numberFeatureTypes from './FeaturesBlock/numberTypeFeatures.json';
    import VFullScreenPopup from '../../components/VFullScreenPopup';
    import {makeFeatureResizable, makeFeatureUnResizable} from './FeaturesBlock/resize';
    import {triggerAdditionalDataCb} from '../../helpers/additionalColumnsHelper';
    import VFeatureVirtualTable from "../../components/VFeatureBlock/VFeatureVirtualTable.vue";

    export default {
        name: 'FeaturesBlock',
        components: {
          VFeatureVirtualTable,
            VFullScreenPopup,
            VFeatureBlock,
            draggable,
        },
        props: {
            features: {
                type: Array,
                required: true,
            },
            featuresData: {
                type: Array,
                required: true,
            },
            events: {
                type: Array,
                required: true,
            },
            deletedEventsAndFormulasIndexes: {
                type: Array,
                required: true,
            },
            allEventsAndAllFormulas: {
                type: Array,
                required: true,
            },
            formulas: {
                type: Array,
                required: true,
            },
            precisions: {
                type: Array,
                required: true,
            },
            currentPrecision: {
                type: String,
                required: true,
            },
            isFeaturesUpdating: {
                type: Boolean,
                required: true,
            },
            isSummaryTableUpdating: {
                type: Boolean,
                required: true,
            },
            featuresSettings: {
                type: Object,
                required: true,
            },
            allEvents: {
                type: Array,
                required: true,
            },
            allFormulas: {
                type: Array,
                required: true,
            },
            isMenuCollapsed: {
                type: Boolean,
                required: true,
            },
            isEditMode: {
                type: Boolean,
                required: true,
            },
            currentBoardClass: {
                type: String,
                required: true,
            },
            currentBoard: {
                type: Object,
                required: true,
            },
            boardStyles: {
                type: Object,
                required: true,
            },
            projects: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                localPrecision: {
                    name: 'day',
                },
                showHeadersNames: [],
                headersWidth: [],
                styles: {
                    selectionStyles: '',
                },
                numberFeatureTypes,
                isShowChartPopup: false,
                isShowTablePopup: false,
                chartPopup: {
                    title: '',
                    featureIndex: 0,
                },
                tablePopup: {
                    featureIndex: null,
                },
                chartComponent: '',
                chartData: {
                    datasets: '',
                    labels: '',
                },
                chartOptions: {},
                bundleIdsOptions: [],
                eventSwitcherOptions: [],
            };
        },
        created() {
            this.initClearData();
            eventBus.$on('App-event-mousedown', this.handleGlobalMouseDown);
            eventBus.$on('App-event-lostFocus', this.handleGlobalLostFocus);
            const self = this;
            document.body.addEventListener('keydown', function (e) {
                e = e || window.event;
                const key = e.which || e.keyCode; // keyCode detection
                const ctrl = e.ctrlKey ? e.ctrlKey : key === 17; // ctrl detection
                const meta = e.metaKey;
                if (key === 67 && ctrl || key === 67 && meta) {
                    self.copyText();
                }
            }, false);

        },
        beforeDestroy() {
            eventBus.$off('App-event-mousedown', this.handleGlobalMouseDown);
            eventBus.$off('App-event-lostFocus', this.handleGlobalLostFocus);
        },
        methods: {
            addGeoData(row){
              this.$emit('addGeoData',row);
            },
            initClearData() {
                this.lastSelectedRow = {
                    featureIndex: null,
                    firstRowIndex: null,
                    firstRowUniqueId: null,
                    shiftRowIndex: null,
                    direction: null,
                    isShifted: false,
                };
                this.featureResize = {
                    element: '',
                    isActive: false,
                };
                this.tableSelection = null;
            },
            escapeButton() {
                this.isShowChartPopup = false;
                this.isShowTablePopup = false;
            },
            updateArppuCoef() {
                this.currentBoard.arppuCoef = !this.currentBoard.arppuCoef;
                const shortFeatureName = 'summary';
                const additionalColumns = this.currentBoard.additionalColumnsByFeatureName[shortFeatureName];
                additionalColumns.forEach((column) => {
                    this.$nextTick(() => {
                        triggerAdditionalDataCb(this.currentBoard, shortFeatureName, column.updateFeaturesNames,
                            {});
                    });
                });
                this.$emit('updateStateForBoards','updateArppuCoef')
                eventBus.$emit('FormulasBlockUpdateArppuCoef');
            },
            checkIfCells(event) {
                return event.target.matches('.VFeatureBlock-data-column') ||
                    event.target.matches('.VFeatureBlock-item__name') || event.target.matches('.VFeatureBlock-headers__name');
            },
            handleGlobalMouseDown(event) {
                if (!this.checkIfCells(event)) {
                    this.clearTableSelection(event);
                }
            },
            handleGlobalLostFocus() {
                if (this.tableSelection) {
                    const featureIndex = this.featuresData.findIndex((feature) => feature.name.split(' ')[0] ===
                        this.tableSelection.shortFeatureName);
                    this.$refs.vfeatureblock[featureIndex].handleGlobalMouseUp();
                }
            },
            clearTableSelection() {
                if (this.tableSelection) {
                    const featureIndex = this.featuresData.findIndex((feature) => feature.name.split(' ')[0] ===
                        this.tableSelection.shortFeatureName);
                    this.$refs.vfeatureblock[featureIndex].deleteSelection();
                }
            },
            copyText() {
                if (this.tableSelection) {
                    const featureIndex = this.featuresData.findIndex((feature) => feature.name.split(' ')[0]
                        === this.tableSelection.shortFeatureName);
                    const feature = this.featuresData[featureIndex];
                    let tableStr = '';

                    if (this.tableSelection.isHeaderSelected) {
                        const allHeadersNames = ['name'].concat(this.headersNames);
                        for (let columnIndex = this.tableSelection.start.columnIndex; columnIndex <
                        this.tableSelection.end.columnIndex + 1; columnIndex++) {
                            if (!feature.deletedIndexes.includes(columnIndex - 1)) {
                                let value = allHeadersNames[columnIndex];
                                if (value == null) {
                                    // tableStr += 0;
                                } else {
                                    tableStr += value;
                                }
                                if (columnIndex !== this.tableSelection.end.columnIndex) {
                                    tableStr += '\t';
                                }
                            }
                        }
                    } else {
                      const filteredRows = this.$refs.vfeatureblock[featureIndex].datatableItems;
                      for (let rowIndex = this.tableSelection.start.rowIndex; rowIndex <= this.tableSelection.end.rowIndex; rowIndex++) {
                        const processRow = (row) => {
                          for (let columnIndex = this.tableSelection.start.columnIndex; columnIndex <
                          this.tableSelection.end.columnIndex + 1; columnIndex++) {
                            if (columnIndex > 0) {
                              if (!feature.deletedIndexes.includes(columnIndex - 1)) {
                                let value = row.cells[columnIndex - 1];
                                if (value == null) {
                                  // tableStr += 0;
                                } else {
                                  tableStr += value;
                                }
                                if (columnIndex !== this.tableSelection.end.columnIndex) {
                                  tableStr += '\t';
                                }
                              }
                            } else {
                              const value = row.value;
                              tableStr += `${value}\t`;
                            }
                          }
                          tableStr += '\n';
                        };

                        // Обрабатываем основную строку
                        processRow(filteredRows[rowIndex]);

                        // Проверяем наличие подстрок (subrows) и обрабатываем их
                        if (filteredRows[rowIndex].subrows && filteredRows[rowIndex].subrows.length > 0) {
                          filteredRows[rowIndex].subrows.forEach(subrow => {
                            processRow(subrow);
                          });
                        }
                      }
                    }
                    copyStringToClipboard(tableStr);
                }
            },
            addSelection(shortFeatureName, filteredRows, tableSelection) {
                this.deleteCssRulesLocal(this.styles.selectionStyles);

                if (tableSelection && (!this.tableSelection || shortFeatureName === this.tableSelection.shortFeatureName)) {
                    this.tableSelection = tableSelection;
                    this.tableSelection.shortFeatureName = shortFeatureName;
                    const columnsIndexes = [];

                    for (let i = tableSelection.start.columnIndex; i <= tableSelection.end.columnIndex; i++) {
                        columnsIndexes.push(i + 1);
                    }
                    let backgroundElementsString = '';
                    let borderLeftStylesString = '';
                    let borderRightStylesString = '';
                    let borderTopStylesString = '';
                    let borderBottomStylesString = '';
                    const rowIndexes = [];

                    if (tableSelection.isHeaderSelected) {
                        const featureRowClass = `.VFeatureBlock-${shortFeatureName} .VFeatureBlock-headers`;
                        columnsIndexes.forEach((columnIndex) => {
                            backgroundElementsString += `${featureRowClass} div:nth-child(${columnIndex}),`;
                        });
                        borderLeftStylesString += ` ${featureRowClass} div:nth-child(${tableSelection.start.columnIndex + 1}),`;
                        borderRightStylesString += ` ${featureRowClass} div:nth-child(${tableSelection.end.columnIndex + 1}),`;
                        columnsIndexes.forEach((columnIndex) => {
                            borderTopStylesString += ` ${featureRowClass} div:nth-child(${columnIndex}),`;
                        });
                        columnsIndexes.forEach((columnIndex) => {
                            borderBottomStylesString += ` ${featureRowClass} div:nth-child(${columnIndex}),`;
                        });
                    } else {
                        const featureRowClass = `.VFeatureBlock-${shortFeatureName}-`;
                        for (let i = tableSelection.start.rowIndex; i <= tableSelection.end.rowIndex; i++) {
                            rowIndexes.push(filteredRows[i].uniqueId);
                        }
                        rowIndexes.forEach((rowIndex) => {
                            columnsIndexes.forEach((columnIndex) => {
                                backgroundElementsString += ` ${featureRowClass}${rowIndex} div:nth-child(${columnIndex}),`;
                            });
                        });
                        rowIndexes.forEach((rowIndex) => {
                            borderLeftStylesString += ` ${featureRowClass}${rowIndex} div:nth-child(${tableSelection.start.columnIndex + 1}),`;
                        });
                        rowIndexes.forEach((rowIndex) => {
                            borderRightStylesString += ` ${featureRowClass}${rowIndex} div:nth-child(${tableSelection.end.columnIndex + 1}),`;
                        });
                        columnsIndexes.forEach((columnIndex) => {
                            borderTopStylesString += ` ${featureRowClass}${rowIndexes[0]} div:nth-child(${columnIndex}),`;
                        });
                        columnsIndexes.forEach((columnIndex) => {
                            borderBottomStylesString += ` ${featureRowClass}${rowIndexes[rowIndexes.length - 1]} div:nth-child(${columnIndex}),`;
                        });
                    }

                    this.styles.selectionStyles = this.createCssRulesLocal(() => {
                        backgroundElementsString = backgroundElementsString.substring(0, backgroundElementsString.length - 1);
                        borderLeftStylesString = borderLeftStylesString.substring(0, borderLeftStylesString.length - 1);
                        borderRightStylesString = borderRightStylesString.substring(0, borderRightStylesString.length - 1);
                        borderTopStylesString = borderTopStylesString.substring(0, borderTopStylesString.length - 1);
                        borderBottomStylesString = borderBottomStylesString.substring(0, borderBottomStylesString.length - 1);

                        const backgroundColor = '#E7EEFC';
                        const borderColor = '#A3BBF1';

                        return [`${backgroundElementsString} {background: ${backgroundColor};}`,
                            `${borderLeftStylesString} {border-left: 1px solid ${borderColor};}`,
                            `${borderRightStylesString} {border-right: 1px solid ${borderColor};}`,
                            `${borderTopStylesString} {border-top: 1px solid ${borderColor};}`,
                            `${borderBottomStylesString} {border-bottom: 1px solid ${borderColor};}`,
                        ];
                    });
                } else if (this.tableSelection && shortFeatureName !== this.tableSelection.shortFeatureName) {
                    this.tableSelection.shortFeatureName = shortFeatureName;
                }
            },
            swapTableBlocks() {
                this.$emit('updateFeaturesOrder');
            },
            selectRow(featureIndex, rowUniqueId) {
                this.clearRowsFromPreviousFeature(featureIndex, true);
                const currentFeature = this.featuresData[featureIndex];
                let newSelectedIds = _.cloneDeep(currentFeature.selectedIds);
                if (newSelectedIds.includes(rowUniqueId)) {
                    newSelectedIds = newSelectedIds.filter((id) => id !== rowUniqueId);
                } else {
                    newSelectedIds.push(rowUniqueId);
                    this.lastSelectedRow.featureIndex = featureIndex;
                    this.lastSelectedRow.isShifted = false;
                    this.lastSelectedRow.firstRowUniqueId = rowUniqueId;
                }
                if (newSelectedIds.length) {
                    this.$emit('updateFeatureFiltersId', featureIndex);
                } else {
                    this.$emit('updateFeatureFiltersId', null);
                }
                currentFeature.selectedIds = Object.freeze(newSelectedIds);
            },
            sumRows(featureIndex) {
                const currentFeature = this.featuresData[featureIndex];
                const selectedIds = _.cloneDeep(currentFeature.selectedIds);
                const sum = _.cloneDeep(this.featuresData[featureIndex].rows.find((row) => row.uniqueId === selectedIds[0]));
                const allSumIds = sortByNumber(this.featuresData[featureIndex].sumRows.map((sR) => sR.id));
                const fractionalEvents = fractionalEventsWithOriginalNames;
                const fractionalEventsIndexes = [];
                const eventNames = currentFeature.events.map((e) => replaceFullName(e.name));
                eventNames.forEach((eventName, eventIndex) => {
                    if (fractionalEvents.includes(eventName)) {
                        fractionalEventsIndexes.push(eventIndex);
                    }
                });
                let emptySumId = allSumIds.length + 1;
                for (let i = 0; i < allSumIds.length; i++) {
                    if (allSumIds[i] !== i + 1) {
                        emptySumId = i + 1;
                        break;
                    }
                }
                sum.value = `sum${emptySumId}`;
                sum.id = emptySumId;
                selectedIds.splice(0, 1);
                selectedIds.forEach((id, index) => {
                    const row = this.featuresData[featureIndex].rows.find((row) => row.uniqueId === id);

                    for (let i = 0; i < this.allEvents.length; i++) {
                        const cellValue = row.cells[i];

                        let newValue = 0;
                        if (cellValue) {
                            if (fractionalEventsIndexes.includes(index)) {
                                newValue = (+sum.cells[i] + +cellValue).toFixed(2);

                            } else {
                                newValue = roundNumber(+sum.cells[i] + +cellValue);
                            }
                            sum.cells[i] = newValue;
                        }
                    }
                });
                const parser = new Parser();
                for (let i = 0; i < this.allEvents.length; i++) {
                    parser.setVariable(replaceFullName(this.allEvents[i].name), sum.cells[i]);
                }
                for (let i = 0; i < this.allFormulas.length; i++) {
                    const cellIndex = this.allEvents.length + i;
                    const formula = this.allFormulas[i];
                    const res = parser.parse(replacePartFormulaName(formula.equation));
                    sum.cells[cellIndex] = res.result ? roundNumber(res.result) : '';
                }
                currentFeature.sumRows.push(sum);
                this.$refs.vfeatureblock[featureIndex].calcWidthForColumns();
                this.clearRowsFromFeature(featureIndex);
            },
            deleteSumRow(featureIndex, rowIndex) {
                const currentFeature = this.featuresData[featureIndex];
                currentFeature.sumRows.splice(rowIndex, 1);
                this.$refs.vfeatureblock[featureIndex].calcWidthForColumns();
            },
            selectAllRowExceptClicked(featureIndex, shiftRowUniqueId) {
                const rows = this.featuresData[featureIndex].rows;
                const rowUniqueIds = [];
                const rowNames = [];
                rows.forEach((row) => {
                    const uniqueId = row.uniqueId;
                    if (shiftRowUniqueId !== uniqueId) {
                        rowUniqueIds.push(uniqueId);
                        rowNames.push(row.value);
                    }
                });
                this.featuresData[featureIndex].selectedIds = Object.freeze(rowUniqueIds);
                this.$emit('applyFilter', this.features.findIndex((feature) => feature.name ===
                    this.featuresData[featureIndex].name), rowNames, 'equal');
            },
            selectRowWithShift(featureIndex, shiftRowUniqueId, shiftRowIndex) {
                const currentFeatureRowsFiltered = this.$refs.vfeatureblock[featureIndex].datatableItems;
                const currentFirstRowIndex = this.$refs.vfeatureblock[featureIndex].datatableItems.findIndex((item) => item.uniqueId === this.lastSelectedRow.firstRowUniqueId);
                const shiftSelectRows = (from, to) => {
                    let newSelectedIds = _.cloneDeep(this.featuresData[featureIndex].selectedIds);
                    for (let i = from; i <= to; i++) {
                        newSelectedIds.push(currentFeatureRowsFiltered[i].uniqueId);
                    }
                    this.featuresData[featureIndex].selectedIds = Object.freeze(newSelectedIds);
                };

                const shiftClearRows = (from, to) => {
                    let newSelectedIds = _.cloneDeep(this.featuresData[featureIndex].selectedIds);
                    for (let i = from; i <= to; i++) {
                        const unfilteredRowId = currentFeatureRowsFiltered[i].uniqueId;
                        newSelectedIds = newSelectedIds.filter((id) => id !== unfilteredRowId);
                    }
                    this.featuresData[featureIndex].selectedIds = Object.freeze(newSelectedIds);
                };
                const isShiftClickedSameFeature = this.lastSelectedRow.featureIndex === featureIndex;
                if (isShiftClickedSameFeature) {
                    if (this.lastSelectedRow.isShifted) {
                        this.clearRowsFromPreviousFeature(featureIndex, false);
                    } else {
                        this.clearRowsFromPreviousFeature(null, false);
                        this.selectRow(featureIndex, this.lastSelectedRow.firstRowUniqueId);
                        this.lastSelectedRow.isShifted = true;
                    }
                    if (currentFirstRowIndex < shiftRowIndex) {
                        if (this.lastSelectedRow.direction == null) {
                            shiftSelectRows(currentFirstRowIndex + 1, shiftRowIndex);
                        } else if (this.lastSelectedRow.direction === 'ascending' &&
                            this.lastSelectedRow.shiftRowIndex < shiftRowIndex) {
                            shiftSelectRows(this.lastSelectedRow.shiftRowIndex + 1, shiftRowIndex);
                        } else if (this.lastSelectedRow.direction === 'ascending' &&
                            this.lastSelectedRow.shiftRowIndex > shiftRowIndex) {
                            shiftClearRows(shiftRowIndex + 1, this.lastSelectedRow.shiftRowIndex);
                        } else if (this.lastSelectedRow.direction === 'descending') {
                            shiftClearRows(
                                this.lastSelectedRow.shiftRowIndex, currentFirstRowIndex - 1);
                            shiftSelectRows(currentFirstRowIndex + 1, shiftRowIndex);
                        }
                        this.lastSelectedRow.direction = 'ascending';
                    } else {
                        if (this.lastSelectedRow.direction == null) {
                            shiftSelectRows(shiftRowIndex, currentFirstRowIndex - 1);
                        } else if (this.lastSelectedRow.direction === 'descending' &&
                            shiftRowIndex < this.lastSelectedRow.shiftRowIndex) {
                            shiftSelectRows(shiftRowIndex, this.lastSelectedRow.shiftRowIndex - 1);
                        } else if (this.lastSelectedRow.direction === 'descending' &&
                            shiftRowIndex > this.lastSelectedRow.shiftRowIndex) {
                            shiftClearRows(this.lastSelectedRow.shiftRowIndex, shiftRowIndex - 1);
                        } else if (this.lastSelectedRow.direction === 'ascending') {
                            shiftClearRows(currentFirstRowIndex + 1,
                                this.lastSelectedRow.shiftRowIndex);
                            shiftSelectRows(shiftRowIndex, currentFirstRowIndex - 1);
                        }
                        this.lastSelectedRow.direction = 'descending';
                    }
                    this.lastSelectedRow.shiftRowIndex = shiftRowIndex;
                } else {
                    this.selectRow(featureIndex, shiftRowUniqueId);
                }
            },
            clearRowsFromPreviousFeature(featureIndex, clearLastSelected = true) {
                if (this.lastSelectedRow.featureIndex !== null && featureIndex !== this.lastSelectedRow.featureIndex) {
                    this.featuresData[this.lastSelectedRow.featureIndex].selectedIds = [];
                }

                if (clearLastSelected) {
                    this.clearLastSelectedRow();
                }
            },
            clearLastSelectedRow() {
                this.lastSelectedRow.featureIndex = null;
                this.lastSelectedRow.firstRowUniqueId = null;
                this.lastSelectedRow.shiftRowIndex = null;
                this.lastSelectedRow.direction = null;
            },
            clearRowsFromFeature(featureIndex) {
                this.featuresData[featureIndex].selectedIds = [];
                this.clearLastSelectedRow();
                this.$emit('updateFeatureFiltersId', null);
            },
            applySelection(featureIndex, color) {
                const coloredRows = [];
                let selectedIds = this.featuresData[featureIndex].selectedIds;
                this.featuresData[featureIndex].rows.forEach((row) => {
                    if (selectedIds.includes(row.uniqueId)) {
                        row.color = color;
                        this.featuresData[featureIndex].itemsChanges[row.uniqueId].color = color;
                        coloredRows.push({
                            color: color,
                            feature: this.featuresData[featureIndex].name,
                            value: row.value,
                        });
                    }
                });
                apiFeatures.colorFeatureRows(coloredRows).then(() => {
                });
                const uniqueColors =
                    [...new Set(this.featuresData[featureIndex].rows.map((row) => row.color))].filter((color) =>
                        color.length);
                this.featuresData[featureIndex].colors = Object.freeze(uniqueColors);
                this.featuresData[featureIndex].selectedIds = Object.freeze([]);
                this.featuresData[featureIndex].selectedColors =
                    this.featuresData[featureIndex].selectedColors.filter((color) => uniqueColors.includes(color));
                this.$refs.vfeatureblock[featureIndex].filterByName();
                this.clearLastSelectedRow();
                this.$emit('updateFeatureFiltersId', null);
            },
            filterClickedRow(featureIndex, rowIndex, filterType) {
                const featureArrayIndex = this.features.findIndex((feature) => feature.name ===
                    this.featuresData[featureIndex].name);
                const rowName = this.featuresData[featureIndex].rows[rowIndex].value;
                this.$emit('applyFilter', featureArrayIndex, [rowName], filterType);
            },
            filterClickedRowSummaryTable(featureIndex, rowIndex) {
                const rowName = this.featuresData[featureIndex].rows[rowIndex].value;
                this.$emit('applyFilterSummaryTable', [rowName]);
            },
            closeFeature(index) {
                const featureData = this.featuresData[index];
                const featureIndex = this.features.findIndex((feature) => feature.name === featureData.name);
                this.$emit('closeFeature', featureIndex, featureData);
            },
            showTooltip(event, tooltipFunction, data) {
                this.$emit('showTooltip', event, tooltipFunction, data);
            },
            catchFeaturesEvent(event) {
                if (!this.featureResize.isActive && this.featureResize.element !==
                    event.target.closest('.VFeatureBlock') && !this.isShowTablePopup) {
                    this.makeFeatureUnResizable();
                    const featuresElements = document.querySelectorAll('.VFeatureBlock');
                    this.featureResize.element = event.target.closest('.VFeatureBlock');
                    for (let i = 0; i < featuresElements.length; i++) {
                        if (featuresElements[i] === this.featureResize.element) {
                            makeFeatureResizable.call(this, featuresElements, featuresElements[i], i, featuresElements[i - 1]);
                            break;
                        }
                    }
                }
            },
            makeFeatureUnResizable(previousElement) {
                makeFeatureUnResizable.call(this, previousElement);
            },
            saveDashboardDebouncedLong() {
                this.$emit('saveDashboardDebouncedLong');
            },
            saveDashboard() {
                this.$emit('saveDashboard');
            },
            changeFeatureViewType(feature, property, value) {
                if (this.isShowTablePopup && value !== 'Table') {
                    this.hideTablePopup();
                    this.rerenderChartPopup();
                } else if (this.isShowChartPopup && value === 'Table') {
                    this.hideChartPopup();
                    this.showTablePopup(feature);
                }
                this.updateFeatureSettingsByProperty(feature.name, property, value);
            },
            updateFeatureSettingsByProperty(featureName, property, value) {
                const newFeaturesSettings = _.cloneDeep(this.featuresSettings);
                newFeaturesSettings[featureName] = newFeaturesSettings[featureName] || {};
                if (JSON.stringify(newFeaturesSettings[featureName][property]) !== JSON.stringify(value)) {
                    newFeaturesSettings[featureName][property] = value;
                    this.$emit('updateFeaturesSettings', newFeaturesSettings);
                }
            },
            updateFeatureSettingsByProperties(featureName, properties) {
                const newFeaturesSettings = _.cloneDeep(this.featuresSettings);
                newFeaturesSettings[featureName] = newFeaturesSettings[featureName] || {};
                Object.assign(newFeaturesSettings[featureName], properties);
                this.$emit('updateFeaturesSettings', newFeaturesSettings);
            },
            updatePrecision(precisionObj) {
                this.$emit('updateCurrentPrecision', precisionObj.name);
            },
            updateSummaryCohort() {
                this.$emit('updateSummaryCohort', !this.currentBoard.groupByCohort);
            },
            changeFeatureChart(viewIndex, view) {
                this.$refs.vfeatureblock[this.chartPopup.featureIndex].changeFeatureChart(viewIndex);
                if (view.name !== 'Table') {
                    this.rerenderChartPopup();
                }
            },
            rerenderChartPopup() {
                this.hideChartPopup();
                this.$nextTick(() => {
                    this.$refs.vfeatureblock[this.chartPopup.featureIndex].showChartPopup();
                });
            },
            calcHeadersWidth(headers) {
                const columnsWidth = [];
                headers.forEach((header) => {
                    columnsWidth.push(getTextWidth(header));
                });
                this.headersWidth = columnsWidth;
            },
            createCssRulesLocal(callback) {
                return createCssRules.call(this, callback);
            },
            deleteCssRulesLocal(cssStyleObj) {
                deleteCssRules.call(this, cssStyleObj);
            },
            showChartPopup(component, data, options, featureName) {
                this.chartPopup.title = featureName;
                this.chartComponent = component;
                this.chartData = data;
                this.chartOptions = options;
                this.chartPopup.featureIndex = this.featuresData.findIndex((feature) => feature.name === featureName);
                this.isShowChartPopup = true;
            },
            showTablePopup(feature) {
                this.makeFeatureUnResizable();
                this.tablePopup.featureIndex = this.featuresData.findIndex((featureD) => featureD.name === feature.name);
                this.isShowTablePopup = true;
            },
            hideChartPopup() {
                this.isShowChartPopup = false;
            },
            hideTablePopup() {
                this.isShowTablePopup = false;
            },
            getChartData(data, options) {
                this.chartData = data;
                this.chartOptions = options;
            },
            removeEvent(event) {
                this.$refs.vfeatureblock[this.chartPopup.featureIndex].removeEvent(event);
            },
            addEvent(event) {
                this.$refs.vfeatureblock[this.chartPopup.featureIndex].addEvent(event);
            },
            removeFormula(formula) {
                this.$refs.vfeatureblock[this.chartPopup.featureIndex].removeFormula(formula);
            },
            addFormula(formula) {
                this.$refs.vfeatureblock[this.chartPopup.featureIndex].addFormula(formula);
            },
            generateEventSwitcherOptions(eventName) {
                const eventSwitcherOptions = this.events.map((event) => {
                    return {
                        name: event.name,
                        isSelected: event.name === eventName,
                    };
                });
                if (eventSwitcherOptions.every((event) => !event.isSelected)) {
                    eventSwitcherOptions[0].isSelected = true;
                }
                this.eventSwitcherOptions = eventSwitcherOptions;
            },
        },
        watch: {
            currentPrecision: {
                immediate: true,
                handler(precision) {
                    if (precision !== this.localPrecision.name) {
                        this.localPrecision.name = precision;
                    }
                },
            },
            allEventsAndAllFormulas: {
                immediate: true,
                deep: true,
                handler() {
                    const eventsNames = this.allEvents.map((e) => longNameEventsShortcuts[e.name] ? longNameEventsShortcuts[e.name] : e.name.substring(0, 3));
                    const formulasNames = this.allFormulas.map((e) => e.name);
                    this.showHeadersNames = eventsNames.concat(formulasNames);
                    this.calcHeadersWidth(this.showHeadersNames);
                },
            },
            projects: {
                immediate: true,
                handler() {
                    this.bundleIdsOptions = this.projects.map((project) => {
                        return {
                            ...project,
                            isActive: true,
                        };
                    });
                },
            },
            events: {
                immediate: true,
                handler() {
                    let currentEventName;
                    if (this.featuresSettings['bundle_id'] && this.featuresSettings['bundle_id'].chartData &&
                        this.featuresSettings['bundle_id'].chartData.eventName) {
                        currentEventName = this.featuresSettings['bundle_id'].chartData.eventName;
                    } else {
                        currentEventName = this.events[0].name;
                    }
                    this.generateEventSwitcherOptions(currentEventName);
                },
            },
        },
        computed: {
            tablePopupFeature() {
                return this.featuresData[this.tablePopup.featureIndex];
            },
            deletedPopupEvents() {
                return this.$refs.vfeatureblock[this.chartPopup.featureIndex].getDeletedEvents().map(({name}) => name);
            },
            deletedPopupFormulas() {
                return this.$refs.vfeatureblock[this.chartPopup.featureIndex].getDeletedFormulas().map(({name}) => name);
            },
            headersNames() {
                return this.allEventsAndAllFormulas.map((all) => all.name);
            },
            featuresNames() {
                return this.features.map((feature) => feature.name);
            },
            precisionsObjects() {
                return Object.freeze(this.precisions.map((feature) => ({name: feature})));
            },
            filtersByObject() {
                return this.currentBoard.filters.reduce((object, currentFilter) => {
                    object[currentFilter.name] = currentFilter;
                    return object;
                }, []);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
  .VTableBlocks {
    margin-top: 10px;

    .summary-VToggle {
      padding-left: 20px;
      display: flex;
      ::v-deep {
        .VToggle{
          margin-right: 10px;
        }
      }
    }

    .popup-sidebar {
      display: flex;
      flex-direction: column;
      list-style-type: none;


      &__label {
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 10px;
      }

      &_display {
        margin-top: 6px;
        margin-bottom: 12px;
      }

      ::v-deep {
        .VSelect-title {
          background: none;
        }

        .VLabel {
          margin-bottom: 2px;
        }

        .VLabel_remove {
          border: 2px solid #F5F5F5;
        }

        .VRadioSwitcher {
          display: flex;
          flex-wrap: wrap;

          .radio {
            margin-bottom: 10px;
          }
        }


      }

      li {
        cursor: pointer;
        margin-top: 5px;
        margin-bottom: 5px;
        text-align: left;
      }

    }

    &-draggable {
      //display: grid;
      //grid-template-columns: 1fr 1fr;
      margin: -10px;
      display: flex;
      flex-wrap: wrap;
    }

    ::v-deep {
      .precision-select {
        z-index: 8;
        position: relative;

        .VButton-select {
          font-weight: bold;
          padding: 7px 16px;

          &:after {
            top: 3px;
          }
        }

        .VSelect-dropdown {
          min-width: unset;

          &__li_dropdown {
            padding: 0;
          }
        }
      }
    }
  }

  .popup {
    &-chart {
      ::v-deep canvas {
        height: calc(100vh - 140px) !important;
        width: calc(100vw - 270px) !important;
      }
    }

    &-table {
      height: 100%;
      padding-right: 5px;

      ::v-deep {
        .VPopup__body {
          height: 100%;
          padding-bottom: 0;
          padding-top: 0;
        }

        .VFeatureBlock-wrapper {
          height: 100%;
          margin: 0;
          margin-right: 4px;

          .VFeatureBlock {
            width: 100% !important;
            height: 100%;
            max-height: 100%;

            &-loading {
              width: 100% !important;
            }
          }

          .root {
            max-height: calc(100vh - 88px);
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>
